import { render, staticRenderFns } from "./DatacenterNewC.vue?vue&type=template&id=6bbc12a8&scoped=true"
import script from "./DatacenterNewC.vue?vue&type=script&lang=js"
export * from "./DatacenterNewC.vue?vue&type=script&lang=js"
import style0 from "./DatacenterNewC.vue?vue&type=style&index=0&id=6bbc12a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc12a8",
  null
  
)

export default component.exports